import Select from "antd/es/select";
import moment from "moment";
import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { DateInput } from "semantic-ui-calendar-react";
import { Button, Icon } from "semantic-ui-react";
import { leaveStatusLabel } from "../../core/constant/myLeaveRequest.constants";
import functionCommon from "../../core/common/function";
import "./styles.scss";

export default function LeavHistoryForm(props) {
    const { leaveTypeList, onChangeConditions, conditions, onSearch, isSearching, dataError } = props;
    const fromDate = conditions.dayFrom;
    const toDate = conditions.dayTo;
    const currentDate = moment().format("DD-MM-YYYY");
    const { t } = useTranslation();

    const handlechangeDateFrom = (event, { name, value }) => {
        onChangeConditions({
            ...conditions,
            dayFrom: value,
        });
    };

    const handlechangeDateTo = (event, { name, value }) => {
        onChangeConditions({
            ...conditions,
            dayTo: value,
        });
    };

    const handleChangeLeaveType = (value) => {
        onChangeConditions({
            ...conditions,
            leaveTypeId: value,
        });
    };

    const handleChangeStatus = (value) => {
        onChangeConditions({
            ...conditions,
            status: value,
        });
    };

    const maxDateFrom = useMemo(() => {
        if (toDate < currentDate) return toDate;
        else return currentDate;
    }, [toDate, currentDate]);

    return (
        <div className="leave-history-form">
            <div className="group-input date-input">
                <div className="date-input-item special">
                    <p className="label">{t("labels.date")}</p>
                    <div className="special-wrapper">
                        <p className="from-label">{t("labels.from")}</p>
                        <DateInput
                            className="date-picker leave-date-picker leave-date-input-restrict"
                            name="date"
                            placeholder="DD-MM-YYYY"
                            iconPosition="right"
                            animation="none"
                            dateFormat="DD-MM-YYYY"
                            value={fromDate}
                            onChange={handlechangeDateFrom}
                            closeOnMouseLeave={false}
                            localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                            hideMobileKeyboard={true}
                            autoComplete="off"
                            maxLength="0"
                            closable={true}
                            onKeyDown={functionCommon.onKeyDownDateInput}
                            onMouseEnter={functionCommon.onMouseEnterDateInput}
                            onMouseLeave={functionCommon.onMouseLeaveDateInput}
                        />
                    </div>
                </div>
                <div className="date-input-item">
                    <p className="to-label">{t("labels.to")}</p>
                    <DateInput
                        className="date-picker leave-date-picker leave-date-input-restrict"
                        name="date"
                        placeholder="DD-MM-YYYY"
                        iconPosition="right"
                        animation="none"
                        dateFormat="DD-MM-YYYY"
                        value={toDate}
                        onChange={handlechangeDateTo}
                        closeOnMouseLeave={false}
                        localization={localStorage.getItem("i18nextLng") === "en" ? "en" : "vi"}
                        hideMobileKeyboard={true}
                        autoComplete="off"
                        maxLength="0"
                        closable={true}
                        onKeyDown={functionCommon.onKeyDownDateInput}
                        onMouseEnter={functionCommon.onMouseEnterDateInput}
                        onMouseLeave={functionCommon.onMouseLeaveDateInput}
                    />
                </div>
            </div>
            {dataError.day && (
                <div className="group-input date-input">
                    <div className="text-error">
                        <p className="error-message error-day">{t(dataError.day)}</p>
                    </div>
                </div>
            )}
            <div className="group-input select-group">
                <div className="normal-input special">
                    <p className="label">{t("labels.leaveType")}</p>
                    <div className="select-wrapper">
                        <Select value={conditions.leaveTypeId} onChange={handleChangeLeaveType}>
                            <Select.Option value="">All</Select.Option>
                            {leaveTypeList.length > 0 &&
                                leaveTypeList.map((ele, idx) => {
                                    return (
                                        <Select.Option key={idx} value={ele.value}>
                                            {ele.name}
                                        </Select.Option>
                                    );
                                })}
                        </Select>
                    </div>
                </div>

                <div className="normal-input">
                    <p className="label">{t("labels.status")}</p>
                    <div className="select-wrapper">
                        <Select value={conditions.status} onChange={handleChangeStatus}>
                            <Select.Option value="">All</Select.Option>
                            {Object.values(leaveStatusLabel).map((ele, idx) => (
                                <Select.Option key={idx} value={idx}>
                                    {t("labels." + ele.toLowerCase())}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                </div>
            </div>
            <div className="btn-wrapper">
                <Button className="leave-button" onClick={onSearch} disabled={isSearching}>
                    <Icon name="search" />
                    {isSearching ? t("button.searching") : t("button.search")}
                </Button>
            </div>
        </div>
    );
}
